import React, { useState } from 'react';
import ViewFilterButton from '../../../../../components/ProTable/ViewFilterButton';
import { useSelector } from 'react-redux';
import { getFilter } from '../../../../../stores/algos-list/getters';
import { updateFilter } from '../../../../../stores/algos-list/actions';
import { tradeTypeOptions } from '../CellTradeType';
import ViewFilterModalDecorated from '../../../../../components/ProTable/ViewFilterModalDecorated';

const ViewTradeType = () => {
  const [open, setOpen] = useState(false);
  const viewsFilter = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });
  const isViewActive = viewsFilter.tradingType ? true : false;

  function onOpen() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }

  return (
    <>
      <ViewFilterButton onClick={onOpen} isActive={isViewActive} />
      {open ? (
        <ViewFilterModalDecorated
          open={open}
          onClose={onClose}
          updateFilter={updateFilter}
          options={tradeTypeOptions}
          viewsFilter={viewsFilter}
          fieldName="tradingType"
          title="Filter Trade type:"
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ViewTradeType;
